/// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.Bindings {
    export class LightSlider {
        public init(element: HTMLElement, valueAccessor: () => LightSliderConfig, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
            //TODO: JQUERY HACK NNO
            var ele = $(element);
            bindingContext.$data.lightSlider = ele;
            ele.lightSlider(valueAccessor());
        }
       
    }
    ko.bindingHandlers['lightSlider'] = new LightSlider();
}